import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

import { styles } from "../../../utils/styles";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
}));

const TabPanel = props => {
  const { customClasses, children, value, index, ...other } = props;
  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      <Box className={customClasses.Box} p={3}>
        {children}
      </Box>
    </Typography>
  );
};

TabPanel.defaultProps = {
  children: null,
  customClasses: {},
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
  customClasses: PropTypes.object,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

/**
 * @desc builds a navigation via tabs
 * @param {array} object - is an array of objects with
 * @param {string} title - title of the tab
 * @param {component} component - react hook component
 * @example tabs={[{title: "test", component: main}]}
 * @return html code
 */

const ScrollableTabs = ({ customStyle, tabs }) => {
  const [value, setValue] = React.useState(0);

  function handleChange(event, newValue) {
    setValue(newValue);
  }
  const customClasses = styles(customStyle);
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <AppBar className={customClasses.appBar} position="static" color="default">
        <Tabs
          style={{ borderBottom: "1px solid #e8e8e8" }}
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          {tabs.map((tab, idx) => {
            // eslint-disable-next-line react/no-array-index-key
            return <Tab key={`${tab.title}_tab_${idx}`} label={tab.title} {...a11yProps(idx)} />;
          })}
        </Tabs>

        {tabs.map((tab, idx) => {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <TabPanel key={`${tab.title}_panel_${idx}`} customClasses={customClasses} value={value} index={idx}>
              {tab.component}
            </TabPanel>
          );
        })}
      </AppBar>
    </div>
  );
};

ScrollableTabs.defaultProps = {
  customStyle: null,
};

ScrollableTabs.propTypes = {
  tabs: PropTypes.array.isRequired,
  customStyle: PropTypes.func,
};

export default ScrollableTabs;
